import colors from '../globals/colors';
var toggle = {
  unChecked: {
    slide: colors.grey72,
    bg: colors.grey8
  },
  disabled: {
    slide: colors.grey0,
    bg: colors.grey24
  },
  hover: {
    slide: colors.secondary.darken,
    bg: colors.toggleBackground
  },
  checked: {
    slide: colors.grey0,
    bg: colors.primary.normal
  }
};
export default toggle;